import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import { browserHistory } from 'react-router';
import Button from '../../../core/form/Button';

const EmailTemplateExpandableTable = (props) => (
  <Table
    columns={[
      {
        label: 'Locale',
        path: 'locale',
        width: '60px',
      },
      {
        label: 'Subject',
        path: 'subject',
      },
      {
        label: 'Actions',
        path: 'template',
        width: '60px',
        render: (cell, row) => <Button icon="download" onClick={() => props.onTemplateDownload(cell)} />,
      },
    ]}
    showTableCount={false}
    rows={props.data}
  />
);

const EmailTemplateList = (props) => (
  <Table
    fetching={props.items.loading}
    expandableComponent={(row) => (
      <EmailTemplateExpandableTable data={row.templates} onTemplateDownload={props.onTemplateDownload} />
    )}
    columns={[
      {
        label: 'Type',
        path: 'type',
        sort: true,
      },
      {
        label: 'Key',
        path: 'key',
        sort: true,
      },
      {
        label: 'Actions',
        path: 'action',
        width: '90px',
        render: (cell, row) => {
          return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button icon="edit" onClick={() => browserHistory.push(`/email-templates/${row.id}`)} />
              <Button icon="delete" onClick={() => props.onDelete(row)} />
            </div>
          );
        },
      },
    ]}
    rows={props.items}
    pagination={props.pagination}
    onDelete={props.onDelete}
  />
);

EmailTemplateList.propTypes = {
  onDelete: PropTypes.func,
  onTemplateDownload: PropTypes.func,
  items: PropTypes.array,
  loading: PropTypes.bool,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    pageSize: PropTypes.number,
    total: PropTypes.number,
  }),
};

EmailTemplateList.defaultProps = {
  items: [],
  loading: false,
};

export default EmailTemplateList;
